import { FC } from 'react';

type Props = {
	className?: string;
};

const Call_02_IconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				d='M7.85645 4.88335L7.66986 4.46349C7.41851 3.89796 7.29283 3.6152 7.08601 3.41533C6.9495 3.2834 6.78884 3.17899 6.61283 3.10782C6.34619 3 6.03675 3 5.41789 3C4.49639 3 4.03565 3 3.67666 3.22372C3.45648 3.36093 3.2459 3.59387 3.13154 3.82674C2.94507 4.20641 2.98737 4.62471 3.07197 5.46131C3.77395 12.4034 7.59597 16.2254 14.538 16.9274C15.3746 17.012 15.793 17.0543 16.1726 16.8678C16.4055 16.7534 16.6384 16.5429 16.7756 16.3227C16.9993 15.9637 16.9993 15.5029 16.9993 14.5815C16.9993 13.9626 16.9993 13.6532 16.8915 13.3865C16.8204 13.2105 16.716 13.0499 16.584 12.9133C16.3842 12.7065 16.1014 12.5808 15.5359 12.3295L15.116 12.1429C14.6205 11.9226 14.3727 11.8125 14.1242 11.7916C13.8598 11.7694 13.5942 11.8187 13.3555 11.9343C13.131 12.0431 12.9393 12.2348 12.5559 12.6182C12.1786 12.9955 11.99 13.1841 11.7443 13.2952C11.5053 13.4032 11.1694 13.4492 10.9101 13.4093C10.6437 13.3682 10.4479 13.2578 10.0562 13.0369C8.66766 12.2537 7.74559 11.3316 6.96246 9.94319C6.74155 9.5515 6.6311 9.35566 6.59006 9.08923C6.55012 8.82995 6.59607 8.49401 6.70416 8.25497C6.81524 8.00933 7.00386 7.82071 7.3811 7.44347C7.76454 7.06002 7.95627 6.8683 8.06501 6.64382C8.18069 6.40506 8.22999 6.13957 8.20773 5.87519C8.18682 5.62665 8.07669 5.37888 7.85645 4.88335Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default Call_02_IconSolid;
